import { Component, computed, Signal } from '@angular/core';
import { DowntimeService } from '../../services/downtime.service';
import { UserService } from '../../services/user.service';
import { UserPermission } from '../../constants/permission.constants.enum';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-header-downtime',
  imports: [TooltipModule],
  templateUrl: './header-downtime.component.html',
  styles: ``
})
export class HeaderDowntimeComponent {

  isActive: Signal<boolean>;
  message: Signal<string>;

  constructor(private downtimeService: DowntimeService, private user: UserService) {
    this.message = computed(() => this.downtimeService.downtime().downtimeMessage);
    this.isActive = computed(() => this.user.permissions().includes(UserPermission.ISADMIN) && this.downtimeService.downtime().isDown);
  }
}
